<template>
  <a
    v-if="waNumber"
    :href="waLink"
    target="_blank"
    rel="noopener noreferrer"
    class="wa-float"
    aria-label="Chat on WhatsApp"
  >
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M16 0C7.163 0 0 7.163 0 16c0 2.823.738 5.47 2.027 7.774L0 32l8.476-2.001A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.76-1.847l-.484-.287-5.03 1.187 1.213-4.895-.314-.503A13.257 13.257 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.865c-.398-.2-2.354-1.162-2.719-1.294-.366-.133-.632-.2-.898.2-.265.398-1.03 1.294-1.263 1.56-.232.265-.465.298-.863.1-.398-.2-1.68-.619-3.2-1.976-1.183-1.056-1.981-2.36-2.213-2.758-.232-.398-.025-.613.175-.81.179-.178.398-.465.597-.697.2-.232.265-.398.398-.664.133-.265.067-.497-.033-.697-.1-.2-.898-2.164-1.23-2.963-.324-.778-.653-.673-.898-.685l-.764-.013c-.265 0-.697.1-.1063.497-.366.398-1.396 1.362-1.396 3.32 0 1.958 1.43 3.849 1.628 4.115.2.265 2.814 4.298 6.817 6.028.953.411 1.697.657 2.277.841.957.304 1.828.261 2.516.158.767-.114 2.354-.963 2.687-1.892.332-.93.332-1.726.232-1.892-.1-.166-.366-.265-.764-.465z"/>
    </svg>
    <span class="wa-tooltip">Chat with us</span>
  </a>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "WhatsAppChat",
  setup() {
    const { content } = useContent("contact", {
      whatsapp_number: "", phone: "",
    });

    // Prefer dedicated whatsapp_number; fall back to phone
    const waNumber = computed(() => {
      const raw = content.value.whatsapp_number || content.value.phone || "";
      return raw.replace(/\D/g, "");
    });

    const waLink = computed(() =>
      `https://wa.me/${waNumber.value}?text=${encodeURIComponent("Hi! I'm interested in GoPlayTV. Can you help me?")}`
    );

    return { waNumber, waLink };
  },
});
</script>

<style scoped>
.wa-float {
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 9999;
  width: 56px;
  height: 56px;
  background: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 18px rgba(37, 211, 102, 0.5);
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;
}
.wa-float svg {
  width: 30px;
  height: 30px;
}
.wa-float:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 24px rgba(37, 211, 102, 0.65);
}
.wa-tooltip {
  position: absolute;
  right: calc(100% + 10px);
  background: #111;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  padding: 5px 10px;
  border-radius: 6px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}
.wa-float:hover .wa-tooltip { opacity: 1; }
</style>
